import { ReactNode, useContext, useMemo } from 'react'

import { CarouselOrListingBlockContext } from './context'
import { useSlideInfo } from './useSlideInfo'

export type LazyLoadItemProp = {
  index: number
  children: (isInView: boolean) => ReactNode
}

export const LazyLoadItem = ({ children, index }: LazyLoadItemProp) => {
  const { embla, filteredChild } = useContext(CarouselOrListingBlockContext)
  const { slideInfo } = useSlideInfo(embla, filteredChild.length)
  const isInView = slideInfo.slidesInView.includes(index - 1)
  const content = useMemo(() => <>{children(isInView)}</>, [isInView])
  return content
}
